import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useOutletContext } from "react-router-dom";
import { toast } from "react-toastify";

import { handleloading } from "../../../Store/Redux/Reducers/Dashboardreducers";
import {
  CatchMessage,
  HandleDeviceId,
  HandleMeterId,
  JSONtoformdata,
  tokenisValid
} from "../../../Shared/Methods";
import { HandleSessionModal } from "../../../Store/Redux/Reducers/Authreducers";
import Loader from "../../../SharedComponents/Loader/Loader";
import classes from "../HomeScreen.module.css";
import Newcommontable from "../../../Components/Tables/NewCommonTable";
import Commonpagination from "../../../Components/Tables/CommonPagination";
import { ReportsListData } from "../../../Services/ApiServices";
import { getDisplayCount } from "../../../Components/Tables/DisplayTableDataCount";
import Failureanalusisreportstable from "../../../Components/Tables/Reports/FailureAnalusisReportsTable";
import Filterfailureanalysisreport from "../../../Components/Filters/Reports/FilterFailureAnalysisReports";

function Failureanalysisreports({ value }: any) {
  const dispatch = useDispatch();
  const { loading } = useSelector((state: any) => state.Dashboard);
  const { LoginData } = useSelector((state: any) => state.Auth);
  const [deviceList, setDeviceList] = useState<any>([]);

  const [Values, setValues] = useState({
    fromDatetime: "",
    toDatetime: "",
    forType: ""
  });
  const [pageSize, setpageSize] = useState(20);
  const [pageind, setPageInd] = useState(0);

  const { showfilter } = useOutletContext<{
    showfilter: boolean;
  }>();

  const renderondeviceID = HandleDeviceId();
  const renderonmeterID = HandleMeterId();

  useEffect(() => {
    if (LoginData !== null) {
      getNotificationReport(1, 20);
    }
  }, [LoginData, renderondeviceID?.deviceId, renderonmeterID?.meter_id]);

  const ResetForm = () => {
    getNotificationReport(1, pageSize, value, true);
    setValues({ fromDatetime: "", toDatetime: "", forType: "" });
  };

  const getNotificationReport = (
    page = 1,
    size = 20,
    filterData?: any,
    isreset = false
  ) => {
    dispatch(handleloading(true));

    let finalObj = {
      ...renderondeviceID,
      ...renderonmeterID,
      token: LoginData?.token
    };

    const WithValues = !isreset
      ? Object.assign(finalObj, filterData ? filterData : Values)
      : finalObj;

    ReportsListData(
      JSONtoformdata(WithValues),
      page,
      size,
      "/report/failureAnalysisReport"
    )
      .then(async (res) => {
        if (res.data.status === 1) {
          setDeviceList(res.data.data);
          if (filterData && !isreset) {
            setValues(filterData);
          }
          setPageInd(page > 1 ? page - 1 : 0);
        } else if (res.data.status === -1) {
          const istokenValid = await tokenisValid(LoginData?.token);
          if (istokenValid) {
            toast.error(res.data.msg);
          } else {
            dispatch(HandleSessionModal(true));
          }
        } else {
          toast.error(res.data.msg);
        }
      })
      .catch((err) => CatchMessage(err))
      .finally(() => {
        dispatch(handleloading(false));
      });
  };

  const Changesize = (current: number, size: number) => {
    // setPageInd(0); //change into 0 from 1
    setpageSize(size);
    getNotificationReport(1, 30, null, false);
  };

  const { page, total_count, size } = deviceList;
  console.log(page, "page");

  return (
    <>
      <Loader isLoader={loading} />
      <div className={classes.table_container_background}>
        <Filterfailureanalysisreport
          showfilter={showfilter}
          GetList={getNotificationReport}
          pageSize={pageSize}
          ResetForm={ResetForm}
        />
        <div>
          {getDisplayCount(deviceList?.page, pageSize, deviceList?.total_count)}
        </div>

        <Newcommontable
          Children={
            <Failureanalusisreportstable
              Data={deviceList}
              pageSize={pageSize}
              pageind={pageind}
              OBJHead={[
                "S.No",
                "Date",
                "Api",
                "Api Response",
                "Call Method",
                "Params",
                "Response Time"
              ]}
              OBJKeys={[
                "datetime",
                "api",
                "api_response",
                "call_method",
                "params",
                "response_time"
              ]}
            />
          }
        />

        <Commonpagination
          onShowSizeChange={Changesize} ///call when page size click
          PageSizeOptions={[20]}
          defaultPageSize={20}
          total={total_count}
          pageSize={size}
          current={page}
          onChange={(e, size) => {
            ///call when page number click
            if (size === pageSize) {
              getNotificationReport(e, size, null, false);
            }
          }}
        />
      </div>
    </>
  );
}

export default Failureanalysisreports;
